import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import copy from 'copy-to-clipboard'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCompanyPageSettings } from 'modules/company_page/hooks/useCompanyPageSettings'

interface Props {
  id: number
  onClose: () => void
}

export const PublishedJobPostingModal = ({ id, onClose }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { buildUrl } = useCompanyPageSettings()

  const jobPostingUrl = buildUrl(`/job_posting/${id}`)

  const copyUrl = async () => {
    if (copy(jobPostingUrl)) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.job_details.url_copied'),
      })
    }
  }

  const onClickPromote = () => {
    onClose()

    navigate(navigation.ats.jobs.jobsId.promotion.fullPath({ jobId: id }))
  }

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('ats.job_details.published_modal.title')}
      footer={
        <>
          <Button.Router
            to={jobPostingUrl}
            rel="nofollow noopener noreferrer"
            type="secondary"
            blankTarget
          >
            {i18n.t('ats.job_details.published_modal.see_job_opening')}
          </Button.Router>
          <Button onClick={() => onClickPromote()}>
            {i18n.t('ats.job_details.published_modal.promote')}
          </Button>
        </>
      }
      onClose={onClose}
    >
      <Box gap="s16">
        <Text.Normal>{i18n.t('ats.job_details.published_modal.description')}</Text.Normal>
        <TextField readonly value={jobPostingUrl} />
        <Button onClick={() => copyUrl()} type="secondary">
          {i18n.t('ats.job_details.published_modal.copy_link')}
        </Button>
      </Box>
    </Modal>
  )
}
